export const getDefaultSelectStyles = (selectStyles = {}) => ({
  valueContainer: (base) => ({
    ...base,
    backgroundColor: 'white',
    border: 'none',
    borderRadius: '16px',
    height: '56px',
    ...selectStyles.valueContainer,
  }),
  container: (base) => ({
    ...base,
    backgroundColor: 'white',
    border: 'none',
    borderRadius: '16px',
    width: '100%',
    ...selectStyles.container,
  }),
  control: (base) => ({
    ...base,
    backgroundColor: 'white',
    border: 'none',
    borderRadius: '16px',
    height: '56px',
    ...selectStyles.control,
  }),
  indicatorSeparator: () => {
    return { display: 'none' };
  },
  singleValue: (base) => ({
    ...base,
    paddingLeft: '16px',
    fontSize: 14,
    fontWeight: 400,
    ...selectStyles.singleValue,
  }),
  input: (base) => ({
    ...base,
    paddingLeft: '16px',
    ...selectStyles.input,
  }),
  menu: (base) => ({
    ...base,
    margin: 0,
    width: '100%',
    backgroundColor: '#FAFAFA',
    borderRadius: '0 0 16px 16px',
    overflow: 'hidden',
    boxShadow: 'none',
    border: 'none',
    marginTop: '1px !important',
    ...selectStyles.menu,
  }),
  menuList: (base) => ({
    ...base,
    borderRadius: '0 0 16px 16px',
    boxShadow: 'none',
    border: 'none',
    '::-webkit-scrollbar': {
      width: '6px',
      height: '0px',
    },
    '::-webkit-scrollbar-track': {
      background: '#FAFAFA',
    },
    '::-webkit-scrollbar-thumb': {
      background: '#156CD7',
    },
    '::-webkit-scrollbar-thumb:hover': {
      background: '#555',
    },
    ...selectStyles.menuList,
  }),
  option: (styles, state) => {
    return {
      ...styles,
      '&:hover': {
        cursor: 'pointer',
        color: '#174091',
        backgroundColor: '#EEF7FF',
      },
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      color: state.isSelected ? '#174091' : '#3A3F52',
      fontWeight: 400,
      fontSize: 14,
      backgroundColor: state.isSelected ? '#EEF7FF' : '#FFF',
      ...selectStyles.option,
    };
  },
  placeholder: (base) => ({
    ...base,
    paddingLeft: '16px',
    fontSize: 14,
    color: '#bfbfbf',
    fontWeight: 400,
    whiteSpace: 'nowrap',
    ...selectStyles.placeholder,
  }),
});

export const borderedSelectStyles = {
  container: {
    border: '1px solid #E0E4EA',
  },
  option: {
    backgroundColor: '#fafafa',
  },
  valueContainer: {
    height: '42px',
  },
  control: {
    height: '42px',
  },
};
